var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-body"},[_c('layout-header'),_vm._v(" "),_c('div',{staticClass:"container main-container main-content mt-5"},[_c('nuxt')],1),_vm._v(" "),_c('layout-footer'),_vm._v(" "),_c('global-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }